import React, { useCallback, useEffect, useReducer, useState } from 'react';
import { useTranslation } from 'react-i18next';

export function GroupValue(props:{value:string}){
    const { t } = useTranslation();
        return <div className='event-group-value'>{t('label.event.group')} : {props.value}</div>
}